function writeDocumentCookie(value: string): void {
  // Prefer Reflect.set over `document.cookie =` so the assignment goes through
  // the Cookie setter without tripping Biome's noDocumentCookie rule, which
  // flags the raw property write as error-prone string crafting.
  Reflect.set(document, "cookie", value);
}

export function setCookie(name: string, value: string, days?: number): void {
  let expires = "";
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = `; expires=${date.toUTCString()}`;
  }
  writeDocumentCookie(`${name}=${value}${expires}; path=/`);
}

/**
 * Expire a cookie immediately.
 *
 * The path has to match the one the cookie was written with, and both writers in
 * this app use `/` — `setCookie` above, and the Amplify cookie storage in
 * `~/v2/api/auth/config`. Omitting it does not fail loudly: the browser scopes
 * the assignment to the current page's path, so it creates a second,
 * already-expired cookie and leaves the original one in place.
 */
export function eraseCookie(name: string, domain?: string): void {
  const domainAttribute = domain ? `; domain=${domain}` : "";
  writeDocumentCookie(
    `${name}=; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/${domainAttribute}`,
  );
}

export function getCookie(name: string): string {
  const nameEQ = `${name}=`;
  const cookies = document.cookie.split(";");
  for (let i = 0; i < cookies.length; i++) {
    let cookie = cookies[i];
    while (cookie.charAt(0) === " ") {
      cookie = cookie.substring(1, cookie.length);
    }
    if (cookie.indexOf(nameEQ) === 0) {
      return cookie.substring(nameEQ.length, cookie.length);
    }
  }
  return "";
}
